module.exports = __webpack_public_path__ + "img/ImageQstep3.cdec29a3.png";